export default __webpack_public_path__ + "static/media/charging.b0970029.gif";